import { useState } from "react";

import { Button } from "#components/Button";
import { SingleSelectDropdown, SingleSelectDropdownItem } from "#components/SingleSelectDropdown";
import { CaretRightIcon } from "#icons";
import { type TimeZoneOption } from "#utils";

interface TimezoneSelectProps {
  timezoneOptions: TimeZoneOption[];
  selected: TimeZoneOption | null;
  onChange: (timezone: TimeZoneOption) => void;
}

export function TimezoneSelect({ timezoneOptions, selected, onChange }: TimezoneSelectProps) {
  const [search, setSearch] = useState("");
  const filteredTimezones = search
    ? timezoneOptions.filter((timezone) =>
        timezone.label.toLowerCase().includes(search.toLowerCase()),
      )
    : timezoneOptions;
  return (
    <SingleSelectDropdown
      AnchorEle={
        <Button IconRight={<CaretRightIcon className="rotate-90" />} variant="tertiary">
          {selected ? `${selected.label} (${selected.abbrev})` : "Local Timezone"}
        </Button>
      }
      className="h-[15rem] w-[15rem] overflow-y-scroll"
      onSearch={(v) => setSearch(v)}
      withSearch
    >
      {filteredTimezones.map((timezone, i) => (
        <SingleSelectDropdownItem key={i} onPress={() => onChange(timezone)}>
          {timezone.label} ({timezone.abbrev})
        </SingleSelectDropdownItem>
      ))}
    </SingleSelectDropdown>
  );
}
